import React, { PropTypes, Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "underscore";
import NoRecords from "../../util/noRecords";
import * as terminalsActions from "../actions/terminalsActions";

import TerminlaList from "../components/terminalList";
import TerminalDetails from "../components/terminalDetails";


class TerminalsPage extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.auth.selectedClientId && this.props.auth.selectedMerchantId)
      this.props.actions.getTerminalList(this.props.auth.selectedClientId, this.props.auth.selectedMerchantId);
  }

  render() {
    let { terminals } = this.props;
    let { terminalId } = this.props.routeParams;

    let mode = "list";
    let matchingTerminal = {};

    if (terminalId) {
      matchingTerminal = _.find(terminals, function(item) { return item.terminalID == terminalId });
      mode = "details";
    }

    return (
      <div className="terminals">
        {mode === "details" && <TerminalDetails details={matchingTerminal} />}
        {mode === "list" && (terminals && terminals.length > 0 ?
          <TerminlaList terminalList={terminals} showOnlyShortList={this.props.showOnlyShortList} /> :
          <NoRecords type="Terminals" />)
        }
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    terminals: state.terminals.list,
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(terminalsActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TerminalsPage);


// WEBPACK FOOTER //
// ./app/terminals/containers/terminalsPage.js